import config from '../config';

const waitlistService = {
  async joinWaitlist(email) {
    try {
      const response = await fetch(`${config.API_URL}/waitlist/join`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to join waitlist');
      }

      return await response.json();
    } catch (error) {
      console.error('Error joining waitlist:', error);
      throw error;
    }
  },

  async checkEmailOnWaitlist(email) {
    try {
      console.log('Checking email on waitlist:', email);
      console.log('API URL:', config.API_URL);
      
      const response = await fetch(`${config.API_URL}/waitlist/check`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Waitlist check result:', result);
      return result;
    } catch (error) {
      console.error('Error checking waitlist:', error);
      throw error;
    }
  },

  async completeWaitlistEntry(email) {
    try {
      console.log('Marking waitlist entry as completed for:', email);
      
      const response = await fetch(`${config.API_URL}/waitlist/complete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Waitlist complete result:', result);
      return result;
    } catch (error) {
      console.error('Error completing waitlist entry:', error);
      throw error;
    }
  }
};

export default waitlistService;